import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaAlocacoesFalhas(props) {
    const { estrutura } = props;
    const { alocacoesFalhas } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "alocacoesFalhas",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Serviço',
                    accessor: 'servico',
                },
                {
                    Header: 'Data',
                    accessor: 'data',
                },
                {
                    Header: 'Hora',
                    accessor: 'hora',
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={alocacoesFalhas}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaAlocacoesFalhas;
